import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import owner from '../images/ssss.jpeg';
import Footer from '../components/Footer';

const SanjeevProfile = () => {
    return (
        <>
            {/* Sanjeev Profile Section - Same format as AboutOwner */}
            <section className="profile-section">
                <div className="container">
                    <div className="row">
                        {/* Content Column */}
                        <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                            <div className="inner-column">
                                <div className="sec-title">
                                    <span className="title">Founder & Visionary</span>
                                    <h2>Sanjeev Kumar</h2>
                                    {/* Social Media Icons - Always Original Colors */}
                                    <div className="social-icons">
                                        <a href="https://www.facebook.com/sanjeev.kumar.44386/" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                                            <i className="fab fa-linkedin-in"></i>
                                        </a>
                                        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
                                            <i className="fab fa-youtube"></i>
                                        </a>
                                    </div>
                                </div>

                                {/* Experience Badge */}
                                <div className="experience-badge">
                                    <span>⭐ 20+ Years Experience in Insurance Industry</span>
                                </div>

                                {/* Professional Highlights */}
                                <h3 className="section-subtitle">Professional Highlights</h3>
                                <ul className="list-style-one">
                                    <li><strong>Have been working for 20+ years</strong> in the insurance sector</li>
                                    <li>Excellent at <strong>communication, leadership, and teamwork</strong></li>
                                    <li>Deep understanding of <strong>customer needs</strong> and market dynamics</li>
                                    <li>Strong passion for the <strong>insurance and financial services industry</strong></li>
                                    <li>High level of <strong>responsibility and accountability</strong></li>
                                    <li>Positive attitude and <strong>high motivation</strong> to drive results</li>
                                    <li>Excellent <strong>English communication skills</strong></li>
                                </ul>

                                {/* Beyond Insurance Section */}
                                <h3 className="section-subtitle mt-4">Beyond Insurance</h3>
                                
                                <div className="achievement-cards">
                                    <div className="achievement-card">
                                        <div className="achievement-icon">🏫</div>
                                        <div className="achievement-content">
                                            <strong>Education Sector Contribution</strong>
                                            <p>Contributed to the <strong>education sector</strong> by adopting <strong>Sumitra Devi Public School</strong> in <strong>Kotiya Bansgaon, Gorakhpur</strong>.</p>
                                        </div>
                                    </div>

                                    <div className="achievement-card">
                                        <div className="achievement-icon">🎙️</div>
                                        <div className="achievement-content">
                                            <strong>Podcast & Media Presence</strong>
                                            <p>Given a voice in journalism through the <strong>Contring Podcast Show</strong> and <strong>Power Talk with Sanjeev</strong>.</p>
                                        </div>
                                    </div>

                                    <div className="achievement-card">
                                        <div className="achievement-icon">📰</div>
                                        <div className="achievement-content">
                                            <strong>Editorial Leadership</strong>
                                            <p>Also plays the role of <strong>Editor</strong> at <strong>Chief of First Finance Magazine</strong>, published in <strong>UP Wealth Terminot</strong>.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Image Column with Button Under Image */}
                        <div className="image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="inner-column wow fadeInLeft">
                                <figure className="image-1">
                                    <img src={owner} alt="Sanjeev Kumar - Founder" />
                                </figure>
                                {/* Stats Row under image */}
                                <div className="profile-stats">
                                    <div className="profile-stat-item">
                                        <h4>20+</h4>
                                        <span>Years Experience</span>
                                    </div>
                                    <div className="profile-stat-item">
                                        <h4>2020</h4>
                                        <span>Founded Agency Bazaar</span>
                                    </div>
                                </div>
                                {/* Button under the stats */}
                                <div className="image-btn-box">
                                    <Link to="/contact" className="image-btn">
                                        Contact Sanjeev <span className="arrow">→</span>
                                    </Link>
                                </div>
                                {/* Bio Section - Moved under Contact Sanjeev Button */}
                                <div className="bio-section">
                                    <div className="bio-box">
                                        <p>
                                            <strong>Sanjeev Kumar</strong> brings over two decades of expertise in the insurance industry.
                                            His strong sense of responsibility, combined with excellent leadership and communication skills,
                                            has helped build <strong>Agency Bazaar</strong> into a trusted platform. With a deep passion for
                                            understanding customer needs and delivering value, he continues to drive innovation and excellence
                                            in health, life, and general insurance solutions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            {/* Font Awesome CDN for Icons */}
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

            {/* Additional CSS */}
            <style jsx>{`
                h1, h2, h3, h4, h5, h6 {}
                a, a:hover, a:focus, a:active {
                    text-decoration: none;
                    outline: none;
                }
                a, a:active, a:focus {
                    color: #6f6f6f;
                    text-decoration: none;
                    transition-timing-function: ease-in-out;
                    transition-duration: .2s;
                }
                ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                img {
                    max-width: 100%;
                    height: auto;
                }

                .profile-section {
                    position: relative;
                    padding: 120px 0 70px;
                }

                .sec-title {
                    position: relative;
                    z-index: 1;
                    margin-bottom: 60px;
                }

                .sec-title .title {
                    position: relative;
                    display: block;
                    font-size: 18px;
                    line-height: 24px;
                    color: #ff2222;
                    font-weight: 500;
                    margin-bottom: 15px;
                }

                .sec-title h2 {
                    position: relative;
                    display: block;
                    font-size: 40px;
                    line-height: 1.28em;
                    color: #222222;
                    font-weight: 600;
                    padding-bottom: 18px;
                }

                .sec-title h2:before {
                    position: absolute;
                    content: '';
                    left: 0px;
                    bottom: 0px;
                    width: 50px;
                    height: 3px;
                    background-color: #d1d2d6;
                }

                /* Social Media Icons */
                .social-icons {
                    display: flex;
                    gap: 15px;
                    margin-top: 20px;
                    margin-bottom: 10px;
                }

                .social-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 42px;
                    height: 42px;
                    border-radius: 50%;
                    font-size: 18px;
                    transition: all 0.3s ease;
                    text-decoration: none;
                    background: transparent;
                }

                .social-icon.facebook {
                    color: #1877f2;
                    background: rgba(24, 119, 242, 0.1);
                    border: 1px solid rgba(24, 119, 242, 0.2);
                }

                .social-icon.instagram {
                    color: #d62976;
                    background: rgba(214, 41, 118, 0.1);
                    border: 1px solid rgba(214, 41, 118, 0.2);
                }

                .social-icon.linkedin {
                    color: #0077b5;
                    background: rgba(0, 119, 181, 0.1);
                    border: 1px solid rgba(0, 119, 181, 0.2);
                }

                .social-icon.youtube {
                    color: #ff0000;
                    background: rgba(255, 0, 0, 0.1);
                    border: 1px solid rgba(255, 0, 0, 0.2);
                }

                .social-icon:hover {
                    transform: translateY(-5px) scale(1.1);
                }

                .social-icon.facebook:hover {
                    background: #1877f2;
                    color: white;
                    box-shadow: 0 8px 20px rgba(24, 119, 242, 0.4);
                    border-color: #1877f2;
                }

                .social-icon.instagram:hover {
                    background: linear-gradient(45deg, #f09433, #d62976, #962fbf);
                    color: white;
                    box-shadow: 0 8px 20px rgba(214, 41, 118, 0.4);
                    border-color: transparent;
                }

                .social-icon.linkedin:hover {
                    background: #0077b5;
                    color: white;
                    box-shadow: 0 8px 20px rgba(0, 119, 181, 0.4);
                    border-color: #0077b5;
                }

                .social-icon.youtube:hover {
                    background: #ff0000;
                    color: white;
                    box-shadow: 0 8px 20px rgba(255, 0, 0, 0.4);
                    border-color: #ff0000;
                }

                /* Experience Badge */
                .experience-badge {
                    display: inline-block;
                    background: linear-gradient(135deg, #ff2222, #cc0000);
                    color: white;
                    padding: 8px 20px;
                    border-radius: 50px;
                    font-weight: 600;
                    font-size: 14px;
                    margin-bottom: 25px;
                }

                /* Section Subtitle */
                .section-subtitle {
                    font-size: 22px;
                    font-weight: 700;
                    color: #ff2222;
                    margin-bottom: 20px;
                    margin-top: 10px;
                }

                /* List Styles */
                .list-style-one {
                    position: relative;
                    margin-bottom: 30px;
                }

                .list-style-one li {
                    position: relative;
                    font-size: 16px;
                    line-height: 26px;
                    color: #222222;
                    font-weight: 400;
                    padding-left: 35px;
                    margin-bottom: 12px;
                }

                .list-style-one li:before {
                    content: "✓";
                    position: absolute;
                    left: 0;
                    top: 0px;
                    display: block;
                    font-size: 18px;
                    padding: 0px;
                    color: #ff2222;
                    font-weight: 600;
                }

                /* Achievement Cards */
                .achievement-cards {
                    margin: 20px 0;
                }

                .achievement-card {
                    display: flex;
                    gap: 15px;
                    background: #f8f9fa;
                    padding: 15px;
                    border-radius: 12px;
                    margin-bottom: 12px;
                    transition: all 0.3s ease;
                    border-left: 3px solid #ff2222;
                }

                .achievement-card:hover {
                    transform: translateX(5px);
                    background: #fff5f5;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                }

                .achievement-icon {
                    font-size: 28px;
                    min-width: 50px;
                }

                .achievement-content strong {
                    color: #ff2222;
                    display: block;
                    margin-bottom: 5px;
                }

                .achievement-content p {
                    margin: 0;
                    color: #555;
                    font-size: 14px;
                    line-height: 1.5;
                }

                /* Image Column */
                .profile-section .content-column {
                    position: relative;
                    margin-bottom: 50px;
                }

                .profile-section .content-column .inner-column {
                    position: relative;
                    padding-left: 30px;
                }

                .profile-section .image-column {
                    position: relative;
                }

                .profile-section .image-column .inner-column {
                    position: relative;
                    padding-left: 120px;
                    padding-bottom: 125px;
                }

                .profile-section .image-column .inner-column:before {
                    position: absolute;
                    left: -75px;
                    top: 65px;
                    height: 520px;
                    width: 520px;
                    background-image: url(https://i.ibb.co/fxJ1jtC/about-circle-1.png);
                    content: "";
                    background-size: contain;
                    background-repeat: no-repeat;
                }

                .profile-section .image-column .image-1 {
                    position: relative;
                    margin-bottom: 25px;
                    display: block;
                    overflow: hidden;
                    border-radius: 15px;
                    transition: all 0.4s ease;
                }

                .profile-section .image-column .image-1 img {
                    box-shadow: 0 30px 50px rgba(8,13,62,.15);
                    border-radius: 15px;
                    width: 100%;
                    height: auto;
                    object-fit: cover;
                    transition: all 0.4s ease;
                }

                .profile-section .image-column .image-1:hover {
                    transform: translateY(-8px);
                }

                .profile-section .image-column .image-1:hover img {
                    box-shadow: 0 40px 60px rgba(255,34,34,0.2);
                    transform: scale(1.02);
                }

                /* Profile Stats under image */
                .profile-stats {
                    display: flex;
                    gap: 15px;
                    justify-content: center;
                    margin: 20px 0;
                }

                .profile-stat-item {
                    text-align: center;
                    padding: 12px 20px;
                    background: #f8f9fa;
                    border-radius: 12px;
                    flex: 1;
                    transition: all 0.3s ease;
                }

                .profile-stat-item:hover {
                    background: #ff2222;
                    transform: translateY(-3px);
                }

                .profile-stat-item h4 {
                    font-size: 24px;
                    font-weight: 700;
                    color: #ff2222;
                    margin-bottom: 5px;
                }

                .profile-stat-item:hover h4,
                .profile-stat-item:hover span {
                    color: white;
                }

                .profile-stat-item span {
                    font-size: 12px;
                    color: #666;
                    font-weight: 500;
                }

                /* Button under image */
                .image-btn-box {
                    text-align: center;
                    margin-top: 10px;
                    margin-bottom: 25px;
                }

                .image-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    background: linear-gradient(135deg, #ff2222 0%, #cc0000 100%);
                    color: #ffffff;
                    padding: 12px 35px;
                    border-radius: 50px;
                    font-weight: 600;
                    font-size: 16px;
                    letter-spacing: 0.5px;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 15px rgba(255,34,34,0.3);
                    border: 2px solid transparent;
                }

                .image-btn .arrow {
                    transition: transform 0.3s ease;
                    font-size: 18px;
                }

                .image-btn:hover {
                    background: linear-gradient(135deg, #001e57 0%, #001240 100%);
                    transform: translateY(-5px);
                    box-shadow: 0 10px 25px rgba(0,30,87,0.4);
                    gap: 15px;
                    border-color: rgba(255,255,255,0.2);
                }

                .image-btn:hover .arrow {
                    transform: translateX(5px);
                }

                /* Bio Section - Under Contact Button */
                .bio-section {
                    margin-top: 20px;
                }

                .bio-box {
                    background: linear-gradient(135deg, #fff5f5, #ffffff);
                    padding: 20px;
                    border-radius: 12px;
                    border: 1px solid rgba(255,34,34,0.2);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                }

                .bio-box p {
                    margin: 0;
                    line-height: 1.8;
                    color: #444;
                    font-size: 15px;
                }

                .bio-box strong {
                    color: #ff2222;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .profile-section {
                        padding: 60px 0;
                    }
                    .profile-section .image-column .inner-column {
                        padding-left: 30px;
                        padding-bottom: 60px;
                    }
                    .profile-section .image-column .inner-column:before {
                        width: 300px;
                        height: 300px;
                        left: -30px;
                        top: 30px;
                    }
                    .sec-title h2 {
                        font-size: 28px;
                    }
                    .social-icons {
                        gap: 12px;
                    }
                    .social-icon {
                        width: 36px;
                        height: 36px;
                        font-size: 16px;
                    }
                    .profile-stats {
                        flex-direction: column;
                    }
                    .bio-box {
                        padding: 15px;
                    }
                    .bio-box p {
                        font-size: 14px;
                    }
                }
            `}</style>
        </>
    );
};

export default SanjeevProfile;


